import { FC, SVGProps } from "react";

export const RectangleIcon: FC<SVGProps<SVGSVGElement>> = ({
  fill = "white",
  className,
  width = 16,
  height = 16,
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        ...style,
      }}
      {...props}
    >
      <path d="M1.5 1.5H11v1H1.5v-1zm13 12H5v1h9.5v-1z" fill={fill}></path>
      <circle r="1.75" cx="2" cy="14" fill={fill}></circle>
      <circle cx="14" cy="2" r="1.75" fill={fill}></circle>
      <path d="M1.5 2.5h1V11h-1zm12 2.5h1v8.5h-1z" fill={fill}></path>
    </svg>
  );
};
